// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: entry/model/EntryPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ModifiersPayload } from "../../common/model/ModifiersPt";
import { WeightClassPayload } from "../../fight/model/FightPt";
import {
  AgeDivisionPayload,
  ageDivisionPayloadFromJSON,
  ageDivisionPayloadToJSON,
} from "../../fight/model/enums/AgeDivisionPt";
import {
  FightSportPayload,
  fightSportPayloadFromJSON,
  fightSportPayloadToJSON,
} from "../../fight/model/enums/FightSportPt";
import { GenderPayload, genderPayloadFromJSON, genderPayloadToJSON } from "../../fight/model/enums/GenderPt";

export const protobufPackage = "io.teamsillim.fightbracket.idl.entry.model";

/**
 * 신청 상태 (체육관이 낸 접수 건 단위)
 *
 * 건 단위로 갈리는 것은 「접수됐나 · 취소됐나」뿐이다.
 * 승인 · 반려는 선수 단위(EntryPlayerStatusPayload)에서만 판정한다.
 */
export enum EntryStatusPayload {
  ENTRY_STATUS_UNKNOWN = 0,
  /** ENTRY_RECEIVED - 접수 완료 */
  ENTRY_RECEIVED = 1,
  /** ENTRY_CANCELED - 취소 */
  ENTRY_CANCELED = 4,
  UNRECOGNIZED = -1,
}

export function entryStatusPayloadFromJSON(object: any): EntryStatusPayload {
  switch (object) {
    case 0:
    case "ENTRY_STATUS_UNKNOWN":
      return EntryStatusPayload.ENTRY_STATUS_UNKNOWN;
    case 1:
    case "ENTRY_RECEIVED":
      return EntryStatusPayload.ENTRY_RECEIVED;
    case 4:
    case "ENTRY_CANCELED":
      return EntryStatusPayload.ENTRY_CANCELED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EntryStatusPayload.UNRECOGNIZED;
  }
}

export function entryStatusPayloadToJSON(object: EntryStatusPayload): string {
  switch (object) {
    case EntryStatusPayload.ENTRY_STATUS_UNKNOWN:
      return "ENTRY_STATUS_UNKNOWN";
    case EntryStatusPayload.ENTRY_RECEIVED:
      return "ENTRY_RECEIVED";
    case EntryStatusPayload.ENTRY_CANCELED:
      return "ENTRY_CANCELED";
    case EntryStatusPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** 선수별 승인 상태 */
export enum EntryPlayerStatusPayload {
  ENTRY_PLAYER_STATUS_UNKNOWN = 0,
  /** ENTRY_PLAYER_APPROVAL_WAITING - 승인 대기 */
  ENTRY_PLAYER_APPROVAL_WAITING = 1,
  /** ENTRY_PLAYER_APPROVED - 승인 완료 */
  ENTRY_PLAYER_APPROVED = 2,
  /** ENTRY_PLAYER_REJECTED - 반려 */
  ENTRY_PLAYER_REJECTED = 3,
  UNRECOGNIZED = -1,
}

export function entryPlayerStatusPayloadFromJSON(object: any): EntryPlayerStatusPayload {
  switch (object) {
    case 0:
    case "ENTRY_PLAYER_STATUS_UNKNOWN":
      return EntryPlayerStatusPayload.ENTRY_PLAYER_STATUS_UNKNOWN;
    case 1:
    case "ENTRY_PLAYER_APPROVAL_WAITING":
      return EntryPlayerStatusPayload.ENTRY_PLAYER_APPROVAL_WAITING;
    case 2:
    case "ENTRY_PLAYER_APPROVED":
      return EntryPlayerStatusPayload.ENTRY_PLAYER_APPROVED;
    case 3:
    case "ENTRY_PLAYER_REJECTED":
      return EntryPlayerStatusPayload.ENTRY_PLAYER_REJECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EntryPlayerStatusPayload.UNRECOGNIZED;
  }
}

export function entryPlayerStatusPayloadToJSON(object: EntryPlayerStatusPayload): string {
  switch (object) {
    case EntryPlayerStatusPayload.ENTRY_PLAYER_STATUS_UNKNOWN:
      return "ENTRY_PLAYER_STATUS_UNKNOWN";
    case EntryPlayerStatusPayload.ENTRY_PLAYER_APPROVAL_WAITING:
      return "ENTRY_PLAYER_APPROVAL_WAITING";
    case EntryPlayerStatusPayload.ENTRY_PLAYER_APPROVED:
      return "ENTRY_PLAYER_APPROVED";
    case EntryPlayerStatusPayload.ENTRY_PLAYER_REJECTED:
      return "ENTRY_PLAYER_REJECTED";
    case EntryPlayerStatusPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * 참가 신청 Payload (TB_ENTRY 과 1:1)
 *
 * entry = 「참가 신청」이다. 「항목」이나 「입력」이 아니다 —
 * application 이 Spring 의 Application 과 겹쳐서 대회 운영 관용어인 entry 를 골랐다.
 *
 * 체육관 단위로 한 번 신청하고 그 안에 선수 여러 명을 담는다.
 * 인증이 없어 조회 · 수정 · 취소는 entryNo 와 체육관 연락처가 함께 맞아야 허용한다.
 */
export interface EntryPayload {
  /** 고유 id */
  id: string;
  /** 신청번호 (예: "2026-000123" — 조회 · 수정 · 취소의 식별자) */
  entryNo: string;
  /** 대회 고유 id */
  tournamentId: string;
  /** 체육관 정보 (신청 시점 스냅샷) */
  gym:
    | EntryGymPayload
    | undefined;
  /** 신청 선수 목록 */
  player: EntryPlayerPayload[];
  /** 신청 상태 */
  status: EntryStatusPayload;
  /** 허위사실 기재 관련 동의 여부 */
  isFalseStatementAgreed: boolean;
  /** 동의 일시 (format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  agreedAt: string;
  /** 취소 사유 (status = ENTRY_CANCELED 일 때만 채워진다) */
  canceledReason: string;
  /** 수정 정보 */
  modifiers: ModifiersPayload | undefined;
}

/** 체육관 정보 (신청 시점 스냅샷 — 체육관 마스터를 참조하지 않는다) */
export interface EntryGymPayload {
  /** 체육관명 */
  name: string;
  /** 담당자명 */
  contactName: string;
  /** 체육관 연락처 (휴대폰 번호, 조회 · 수정 · 취소 검증에 쓰인다) */
  contactPhoneNo: string;
}

/**
 * 신청 선수 Payload (TB_ENTRY_PLAYER 과 1:1)
 *
 * **닭싸움은 이름 · 생년월일 · 성별 · 종목 넷만 받는다.** 무체급이라 고를 체급이 없고
 * 체중으로 나누지 않아 체중 · 경력 · 출전 횟수도 묻지 않는다 — 실려 와도 서버가 버리고,
 * 응답에는 빈 문자열(출전 횟수는 0)로 내려간다. 체급은 서버가 무체급을 넣는다.
 */
export interface EntryPlayerPayload {
  /** 고유 id (신규 신청이면 비어 있다) */
  id: string;
  /** 이름 */
  name: string;
  /** 생년월일 (format = yyyy-MM-dd) */
  birthDate: string;
  /** 성별 */
  gender: GenderPayload;
  /** 참가 종목 */
  sport: FightSportPayload;
  /** 신청 체중 (kg, 소수점 문자열 — 계측 값이 아니라 신청자 입력 값이다). 닭싸움은 받지 않아 빈 문자열이다 */
  weightKg: string;
  /** 운동 경력 (년, 소수점 문자열). 닭싸움은 받지 않아 빈 문자열이다 */
  careerYears: string;
  /** 대회 참가 횟수. 닭싸움은 받지 않아 0 이다 */
  competitionCount: number;
  /**
   * 체급 — **신청자가 고른다**(필수). 대회 당일에 맞춰 오는 목표 체급이라 체중으로 추정하지 않는다.
   * 서버는 sport 와 oneof 만 신뢰하고 선수의 부 · 성별에 맞는지 검사한다. 당일 계체가 다르면 운영자가 고친다.
   * 닭싸움은 무체급 하나뿐이라 고르지 않는다 — 서버가 넣는다
   */
  weightClass:
    | WeightClassPayload
    | undefined;
  /** 선수별 승인 상태 */
  status: EntryPlayerStatusPayload;
  /** 반려 사유 (status = ENTRY_PLAYER_REJECTED 일 때만 채워진다) */
  rejectedReason: string;
  /** 부 — 서버가 생년월일로 산출한다. 요청에 실려 와도 무시한다 */
  division: AgeDivisionPayload;
}

/**
 * 신청 목록 한 줄
 *
 * 체육관 본인 조회 목록과 관리자 목록이 같은 모양을 쓴다.
 * 목록에는 선수 상세를 싣지 않는다 — 선수까지 필요하면 신청번호로 단건 조회한다.
 */
export interface EntrySummaryPayload {
  /** 고유 id */
  id: string;
  /** 신청번호 */
  entryNo: string;
  /** 대회 고유 id */
  tournamentId: string;
  /** 대회명 */
  tournamentName: string;
  /** 대회 시작일시 (format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  tournamentStartAt: string;
  /** 체육관명 */
  gymName: string;
  /** 담당자명 */
  gymContactName: string;
  /** 신청 상태 */
  status: EntryStatusPayload;
  /** 신청 선수 수 */
  playerCount: number;
  /** 신청에 담긴 종목 (중복 없이) */
  sport: FightSportPayload[];
  /** 접수 일시 (format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  appliedAt: string;
  /** 취소 사유 (취소 상태에서만 채워진다) */
  canceledReason: string;
  /** 승인 완료된 선수 수 (목록에서 선수 심사 진행 상황을 집계로 보여준다) */
  approvedPlayerCount: number;
  /** 반려된 선수 수 */
  rejectedPlayerCount: number;
}

/** 신청 검색 조건 (빈 값 · UNKNOWN 은 「전체」다) */
export interface EntrySearchConditionPayload {
  /** 대회 고유 id */
  tournamentId: string;
  /** 체육관명 검색어 */
  gymName: string;
  /** 선수명 검색어 */
  playerName: string;
  /** 신청 상태 필터 */
  status: EntryStatusPayload;
  /** 종목 필터 */
  sport: FightSportPayload;
}

function createBaseEntryPayload(): EntryPayload {
  return {
    id: "",
    entryNo: "",
    tournamentId: "",
    gym: undefined,
    player: [],
    status: 0,
    isFalseStatementAgreed: false,
    agreedAt: "",
    canceledReason: "",
    modifiers: undefined,
  };
}

export const EntryPayload: MessageFns<EntryPayload> = {
  encode(message: EntryPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.entryNo !== "") {
      writer.uint32(18).string(message.entryNo);
    }
    if (message.tournamentId !== "") {
      writer.uint32(26).string(message.tournamentId);
    }
    if (message.gym !== undefined) {
      EntryGymPayload.encode(message.gym, writer.uint32(34).fork()).join();
    }
    for (const v of message.player) {
      EntryPlayerPayload.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(48).int32(message.status);
    }
    if (message.isFalseStatementAgreed !== false) {
      writer.uint32(56).bool(message.isFalseStatementAgreed);
    }
    if (message.agreedAt !== "") {
      writer.uint32(66).string(message.agreedAt);
    }
    if (message.canceledReason !== "") {
      writer.uint32(74).string(message.canceledReason);
    }
    if (message.modifiers !== undefined) {
      ModifiersPayload.encode(message.modifiers, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.entryNo = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.gym = EntryGymPayload.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.player.push(EntryPlayerPayload.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.isFalseStatementAgreed = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.agreedAt = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.canceledReason = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.modifiers = ModifiersPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryPayload {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      entryNo: isSet(object.entryNo) ? globalThis.String(object.entryNo) : "",
      tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "",
      gym: isSet(object.gym) ? EntryGymPayload.fromJSON(object.gym) : undefined,
      player: globalThis.Array.isArray(object?.player)
        ? object.player.map((e: any) => EntryPlayerPayload.fromJSON(e))
        : [],
      status: isSet(object.status) ? entryStatusPayloadFromJSON(object.status) : 0,
      isFalseStatementAgreed: isSet(object.isFalseStatementAgreed)
        ? globalThis.Boolean(object.isFalseStatementAgreed)
        : false,
      agreedAt: isSet(object.agreedAt) ? globalThis.String(object.agreedAt) : "",
      canceledReason: isSet(object.canceledReason) ? globalThis.String(object.canceledReason) : "",
      modifiers: isSet(object.modifiers) ? ModifiersPayload.fromJSON(object.modifiers) : undefined,
    };
  },

  toJSON(message: EntryPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.entryNo !== "") {
      obj.entryNo = message.entryNo;
    }
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    if (message.gym !== undefined) {
      obj.gym = EntryGymPayload.toJSON(message.gym);
    }
    if (message.player?.length) {
      obj.player = message.player.map((e) => EntryPlayerPayload.toJSON(e));
    }
    if (message.status !== 0) {
      obj.status = entryStatusPayloadToJSON(message.status);
    }
    if (message.isFalseStatementAgreed !== false) {
      obj.isFalseStatementAgreed = message.isFalseStatementAgreed;
    }
    if (message.agreedAt !== "") {
      obj.agreedAt = message.agreedAt;
    }
    if (message.canceledReason !== "") {
      obj.canceledReason = message.canceledReason;
    }
    if (message.modifiers !== undefined) {
      obj.modifiers = ModifiersPayload.toJSON(message.modifiers);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryPayload>, I>>(base?: I): EntryPayload {
    return EntryPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryPayload>, I>>(object: I): EntryPayload {
    const message = createBaseEntryPayload();
    message.id = object.id ?? "";
    message.entryNo = object.entryNo ?? "";
    message.tournamentId = object.tournamentId ?? "";
    message.gym = (object.gym !== undefined && object.gym !== null)
      ? EntryGymPayload.fromPartial(object.gym)
      : undefined;
    message.player = object.player?.map((e) => EntryPlayerPayload.fromPartial(e)) || [];
    message.status = object.status ?? 0;
    message.isFalseStatementAgreed = object.isFalseStatementAgreed ?? false;
    message.agreedAt = object.agreedAt ?? "";
    message.canceledReason = object.canceledReason ?? "";
    message.modifiers = (object.modifiers !== undefined && object.modifiers !== null)
      ? ModifiersPayload.fromPartial(object.modifiers)
      : undefined;
    return message;
  },
};

function createBaseEntryGymPayload(): EntryGymPayload {
  return { name: "", contactName: "", contactPhoneNo: "" };
}

export const EntryGymPayload: MessageFns<EntryGymPayload> = {
  encode(message: EntryGymPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.contactName !== "") {
      writer.uint32(18).string(message.contactName);
    }
    if (message.contactPhoneNo !== "") {
      writer.uint32(26).string(message.contactPhoneNo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryGymPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryGymPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.contactName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.contactPhoneNo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryGymPayload {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      contactName: isSet(object.contactName) ? globalThis.String(object.contactName) : "",
      contactPhoneNo: isSet(object.contactPhoneNo) ? globalThis.String(object.contactPhoneNo) : "",
    };
  },

  toJSON(message: EntryGymPayload): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.contactName !== "") {
      obj.contactName = message.contactName;
    }
    if (message.contactPhoneNo !== "") {
      obj.contactPhoneNo = message.contactPhoneNo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryGymPayload>, I>>(base?: I): EntryGymPayload {
    return EntryGymPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryGymPayload>, I>>(object: I): EntryGymPayload {
    const message = createBaseEntryGymPayload();
    message.name = object.name ?? "";
    message.contactName = object.contactName ?? "";
    message.contactPhoneNo = object.contactPhoneNo ?? "";
    return message;
  },
};

function createBaseEntryPlayerPayload(): EntryPlayerPayload {
  return {
    id: "",
    name: "",
    birthDate: "",
    gender: 0,
    sport: 0,
    weightKg: "",
    careerYears: "",
    competitionCount: 0,
    weightClass: undefined,
    status: 0,
    rejectedReason: "",
    division: 0,
  };
}

export const EntryPlayerPayload: MessageFns<EntryPlayerPayload> = {
  encode(message: EntryPlayerPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.birthDate !== "") {
      writer.uint32(26).string(message.birthDate);
    }
    if (message.gender !== 0) {
      writer.uint32(32).int32(message.gender);
    }
    if (message.sport !== 0) {
      writer.uint32(40).int32(message.sport);
    }
    if (message.weightKg !== "") {
      writer.uint32(50).string(message.weightKg);
    }
    if (message.careerYears !== "") {
      writer.uint32(58).string(message.careerYears);
    }
    if (message.competitionCount !== 0) {
      writer.uint32(64).int32(message.competitionCount);
    }
    if (message.weightClass !== undefined) {
      WeightClassPayload.encode(message.weightClass, writer.uint32(74).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(80).int32(message.status);
    }
    if (message.rejectedReason !== "") {
      writer.uint32(90).string(message.rejectedReason);
    }
    if (message.division !== 0) {
      writer.uint32(96).int32(message.division);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryPlayerPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryPlayerPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.birthDate = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.gender = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.sport = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.weightKg = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.careerYears = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.competitionCount = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.weightClass = WeightClassPayload.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.rejectedReason = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.division = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryPlayerPayload {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      birthDate: isSet(object.birthDate) ? globalThis.String(object.birthDate) : "",
      gender: isSet(object.gender) ? genderPayloadFromJSON(object.gender) : 0,
      sport: isSet(object.sport) ? fightSportPayloadFromJSON(object.sport) : 0,
      weightKg: isSet(object.weightKg) ? globalThis.String(object.weightKg) : "",
      careerYears: isSet(object.careerYears) ? globalThis.String(object.careerYears) : "",
      competitionCount: isSet(object.competitionCount) ? globalThis.Number(object.competitionCount) : 0,
      weightClass: isSet(object.weightClass) ? WeightClassPayload.fromJSON(object.weightClass) : undefined,
      status: isSet(object.status) ? entryPlayerStatusPayloadFromJSON(object.status) : 0,
      rejectedReason: isSet(object.rejectedReason) ? globalThis.String(object.rejectedReason) : "",
      division: isSet(object.division) ? ageDivisionPayloadFromJSON(object.division) : 0,
    };
  },

  toJSON(message: EntryPlayerPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.birthDate !== "") {
      obj.birthDate = message.birthDate;
    }
    if (message.gender !== 0) {
      obj.gender = genderPayloadToJSON(message.gender);
    }
    if (message.sport !== 0) {
      obj.sport = fightSportPayloadToJSON(message.sport);
    }
    if (message.weightKg !== "") {
      obj.weightKg = message.weightKg;
    }
    if (message.careerYears !== "") {
      obj.careerYears = message.careerYears;
    }
    if (message.competitionCount !== 0) {
      obj.competitionCount = Math.round(message.competitionCount);
    }
    if (message.weightClass !== undefined) {
      obj.weightClass = WeightClassPayload.toJSON(message.weightClass);
    }
    if (message.status !== 0) {
      obj.status = entryPlayerStatusPayloadToJSON(message.status);
    }
    if (message.rejectedReason !== "") {
      obj.rejectedReason = message.rejectedReason;
    }
    if (message.division !== 0) {
      obj.division = ageDivisionPayloadToJSON(message.division);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryPlayerPayload>, I>>(base?: I): EntryPlayerPayload {
    return EntryPlayerPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryPlayerPayload>, I>>(object: I): EntryPlayerPayload {
    const message = createBaseEntryPlayerPayload();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.birthDate = object.birthDate ?? "";
    message.gender = object.gender ?? 0;
    message.sport = object.sport ?? 0;
    message.weightKg = object.weightKg ?? "";
    message.careerYears = object.careerYears ?? "";
    message.competitionCount = object.competitionCount ?? 0;
    message.weightClass = (object.weightClass !== undefined && object.weightClass !== null)
      ? WeightClassPayload.fromPartial(object.weightClass)
      : undefined;
    message.status = object.status ?? 0;
    message.rejectedReason = object.rejectedReason ?? "";
    message.division = object.division ?? 0;
    return message;
  },
};

function createBaseEntrySummaryPayload(): EntrySummaryPayload {
  return {
    id: "",
    entryNo: "",
    tournamentId: "",
    tournamentName: "",
    tournamentStartAt: "",
    gymName: "",
    gymContactName: "",
    status: 0,
    playerCount: 0,
    sport: [],
    appliedAt: "",
    canceledReason: "",
    approvedPlayerCount: 0,
    rejectedPlayerCount: 0,
  };
}

export const EntrySummaryPayload: MessageFns<EntrySummaryPayload> = {
  encode(message: EntrySummaryPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.entryNo !== "") {
      writer.uint32(18).string(message.entryNo);
    }
    if (message.tournamentId !== "") {
      writer.uint32(26).string(message.tournamentId);
    }
    if (message.tournamentName !== "") {
      writer.uint32(34).string(message.tournamentName);
    }
    if (message.tournamentStartAt !== "") {
      writer.uint32(42).string(message.tournamentStartAt);
    }
    if (message.gymName !== "") {
      writer.uint32(50).string(message.gymName);
    }
    if (message.gymContactName !== "") {
      writer.uint32(58).string(message.gymContactName);
    }
    if (message.status !== 0) {
      writer.uint32(64).int32(message.status);
    }
    if (message.playerCount !== 0) {
      writer.uint32(72).int32(message.playerCount);
    }
    writer.uint32(82).fork();
    for (const v of message.sport) {
      writer.int32(v);
    }
    writer.join();
    if (message.appliedAt !== "") {
      writer.uint32(90).string(message.appliedAt);
    }
    if (message.canceledReason !== "") {
      writer.uint32(98).string(message.canceledReason);
    }
    if (message.approvedPlayerCount !== 0) {
      writer.uint32(104).int32(message.approvedPlayerCount);
    }
    if (message.rejectedPlayerCount !== 0) {
      writer.uint32(112).int32(message.rejectedPlayerCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntrySummaryPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntrySummaryPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.entryNo = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tournamentName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.tournamentStartAt = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.gymName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.gymContactName = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.playerCount = reader.int32();
          continue;
        }
        case 10: {
          if (tag === 80) {
            message.sport.push(reader.int32() as any);

            continue;
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.sport.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.appliedAt = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.canceledReason = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.approvedPlayerCount = reader.int32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.rejectedPlayerCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntrySummaryPayload {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      entryNo: isSet(object.entryNo) ? globalThis.String(object.entryNo) : "",
      tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "",
      tournamentName: isSet(object.tournamentName) ? globalThis.String(object.tournamentName) : "",
      tournamentStartAt: isSet(object.tournamentStartAt) ? globalThis.String(object.tournamentStartAt) : "",
      gymName: isSet(object.gymName) ? globalThis.String(object.gymName) : "",
      gymContactName: isSet(object.gymContactName) ? globalThis.String(object.gymContactName) : "",
      status: isSet(object.status) ? entryStatusPayloadFromJSON(object.status) : 0,
      playerCount: isSet(object.playerCount) ? globalThis.Number(object.playerCount) : 0,
      sport: globalThis.Array.isArray(object?.sport) ? object.sport.map((e: any) => fightSportPayloadFromJSON(e)) : [],
      appliedAt: isSet(object.appliedAt) ? globalThis.String(object.appliedAt) : "",
      canceledReason: isSet(object.canceledReason) ? globalThis.String(object.canceledReason) : "",
      approvedPlayerCount: isSet(object.approvedPlayerCount) ? globalThis.Number(object.approvedPlayerCount) : 0,
      rejectedPlayerCount: isSet(object.rejectedPlayerCount) ? globalThis.Number(object.rejectedPlayerCount) : 0,
    };
  },

  toJSON(message: EntrySummaryPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.entryNo !== "") {
      obj.entryNo = message.entryNo;
    }
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    if (message.tournamentName !== "") {
      obj.tournamentName = message.tournamentName;
    }
    if (message.tournamentStartAt !== "") {
      obj.tournamentStartAt = message.tournamentStartAt;
    }
    if (message.gymName !== "") {
      obj.gymName = message.gymName;
    }
    if (message.gymContactName !== "") {
      obj.gymContactName = message.gymContactName;
    }
    if (message.status !== 0) {
      obj.status = entryStatusPayloadToJSON(message.status);
    }
    if (message.playerCount !== 0) {
      obj.playerCount = Math.round(message.playerCount);
    }
    if (message.sport?.length) {
      obj.sport = message.sport.map((e) => fightSportPayloadToJSON(e));
    }
    if (message.appliedAt !== "") {
      obj.appliedAt = message.appliedAt;
    }
    if (message.canceledReason !== "") {
      obj.canceledReason = message.canceledReason;
    }
    if (message.approvedPlayerCount !== 0) {
      obj.approvedPlayerCount = Math.round(message.approvedPlayerCount);
    }
    if (message.rejectedPlayerCount !== 0) {
      obj.rejectedPlayerCount = Math.round(message.rejectedPlayerCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntrySummaryPayload>, I>>(base?: I): EntrySummaryPayload {
    return EntrySummaryPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntrySummaryPayload>, I>>(object: I): EntrySummaryPayload {
    const message = createBaseEntrySummaryPayload();
    message.id = object.id ?? "";
    message.entryNo = object.entryNo ?? "";
    message.tournamentId = object.tournamentId ?? "";
    message.tournamentName = object.tournamentName ?? "";
    message.tournamentStartAt = object.tournamentStartAt ?? "";
    message.gymName = object.gymName ?? "";
    message.gymContactName = object.gymContactName ?? "";
    message.status = object.status ?? 0;
    message.playerCount = object.playerCount ?? 0;
    message.sport = object.sport?.map((e) => e) || [];
    message.appliedAt = object.appliedAt ?? "";
    message.canceledReason = object.canceledReason ?? "";
    message.approvedPlayerCount = object.approvedPlayerCount ?? 0;
    message.rejectedPlayerCount = object.rejectedPlayerCount ?? 0;
    return message;
  },
};

function createBaseEntrySearchConditionPayload(): EntrySearchConditionPayload {
  return { tournamentId: "", gymName: "", playerName: "", status: 0, sport: 0 };
}

export const EntrySearchConditionPayload: MessageFns<EntrySearchConditionPayload> = {
  encode(message: EntrySearchConditionPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tournamentId !== "") {
      writer.uint32(10).string(message.tournamentId);
    }
    if (message.gymName !== "") {
      writer.uint32(18).string(message.gymName);
    }
    if (message.playerName !== "") {
      writer.uint32(26).string(message.playerName);
    }
    if (message.status !== 0) {
      writer.uint32(32).int32(message.status);
    }
    if (message.sport !== 0) {
      writer.uint32(40).int32(message.sport);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntrySearchConditionPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntrySearchConditionPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.gymName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.playerName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.sport = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntrySearchConditionPayload {
    return {
      tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "",
      gymName: isSet(object.gymName) ? globalThis.String(object.gymName) : "",
      playerName: isSet(object.playerName) ? globalThis.String(object.playerName) : "",
      status: isSet(object.status) ? entryStatusPayloadFromJSON(object.status) : 0,
      sport: isSet(object.sport) ? fightSportPayloadFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: EntrySearchConditionPayload): unknown {
    const obj: any = {};
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    if (message.gymName !== "") {
      obj.gymName = message.gymName;
    }
    if (message.playerName !== "") {
      obj.playerName = message.playerName;
    }
    if (message.status !== 0) {
      obj.status = entryStatusPayloadToJSON(message.status);
    }
    if (message.sport !== 0) {
      obj.sport = fightSportPayloadToJSON(message.sport);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntrySearchConditionPayload>, I>>(base?: I): EntrySearchConditionPayload {
    return EntrySearchConditionPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntrySearchConditionPayload>, I>>(object: I): EntrySearchConditionPayload {
    const message = createBaseEntrySearchConditionPayload();
    message.tournamentId = object.tournamentId ?? "";
    message.gymName = object.gymName ?? "";
    message.playerName = object.playerName ?? "";
    message.status = object.status ?? 0;
    message.sport = object.sport ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
